import AtlasSelect, { OptionType, SelectProps } from '@atlaskit/select';
/** @jsxImportSource @emotion/react */
import React, { ComponentProps, PropsWithChildren, ReactElement } from 'react';
import { jsx, css } from '@emotion/react';
import { FormattedMessage } from 'components/i18n';

const defaultProps = {
  ...AtlasSelect.defaultProps,
  // placeholder: <FormattedMessage
  //   id='components.Select.placeholder'
  //   defaultMessage=' '
  // />
  placeholder: ''
};

AtlasSelect.defaultProps = defaultProps;

export default AtlasSelect;
